import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';
import { updateUser } from 'state';

/**
 * Interface for company info payload
 */
export interface CompanyInfoPayload {
  name: string;
  industry: string;
  hiring_frequency: string;
  no_of_employees: string;
  company_logo?: string;
}

/**
 * Interface for company info response
 */
export interface CompanyInfoResponse {
  message: string;
  company: {
    id: number;
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
    name: string;
    industry: string;
    hiring_frequency: string;
    no_of_employees: string;
    owner: number;
  };
}

/**
 * Hook for posting company info using TanStack React Query
 */
export const usePostCompanyInfo = (
  dispatch: (action: any) => void,
  getUser: () => void,
  user: any,
  setImage: (value: { show: boolean; type: string }) => void
) => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: CompanyInfoPayload) => {
      const response = await apiClient.post<CompanyInfoResponse>('/auth/company/', payload);
      return response.data;
    },
    onSuccess: (data) => {
      getUser();
      dispatch(
        updateUser({
          ...user,
          completedBusiness: true,
        })
      );
      setImage({ show: false, type: '' });
      openToast({
        show: true,
        heading: data.message ?? 'Company profile created!',
        text: '',
        type: 'success',
        timeOut: 2000,
      });
    },
    onError: (err: any) => {
      console.error('Create Company Error:', err); // Log error for debugging
      const errorMessage =
        err?.message ||
        'Failed to create your company profile, please try again later';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};